// Location constants for Canada provinces/territories and US states

export const CANADA_PROVINCES = [
  { code: 'AB', en: 'Alberta', fr: 'Alberta' },
  { code: 'BC', en: 'British Columbia', fr: 'Colombie-Britannique' },
  { code: 'MB', en: 'Manitoba', fr: 'Manitoba' },
  { code: 'NB', en: 'New Brunswick', fr: 'Nouveau-Brunswick' },
  { code: 'NL', en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador' },
  { code: 'NS', en: 'Nova Scotia', fr: 'Nouvelle-Écosse' },
  { code: 'NT', en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest' },
  { code: 'NU', en: 'Nunavut', fr: 'Nunavut' },
  { code: 'ON', en: 'Ontario', fr: 'Ontario' },
  { code: 'PE', en: 'Prince Edward Island', fr: 'Île-du-Prince-Édouard' },
  { code: 'QC', en: 'Quebec', fr: 'Québec' },
  { code: 'SK', en: 'Saskatchewan', fr: 'Saskatchewan' },
  { code: 'YT', en: 'Yukon', fr: 'Yukon' },
];

export const US_STATES = [
  { code: 'AL', en: 'Alabama', fr: 'Alabama' },
  { code: 'AK', en: 'Alaska', fr: 'Alaska' },
  { code: 'AZ', en: 'Arizona', fr: 'Arizona' },
  { code: 'AR', en: 'Arkansas', fr: 'Arkansas' },
  { code: 'CA', en: 'California', fr: 'Californie' },
  { code: 'CO', en: 'Colorado', fr: 'Colorado' },
  { code: 'CT', en: 'Connecticut', fr: 'Connecticut' },
  { code: 'DE', en: 'Delaware', fr: 'Delaware' },
  { code: 'FL', en: 'Florida', fr: 'Floride' },
  { code: 'GA', en: 'Georgia', fr: 'Géorgie' },
  { code: 'HI', en: 'Hawaii', fr: 'Hawaï' },
  { code: 'ID', en: 'Idaho', fr: 'Idaho' },
  { code: 'IL', en: 'Illinois', fr: 'Illinois' },
  { code: 'IN', en: 'Indiana', fr: 'Indiana' },
  { code: 'IA', en: 'Iowa', fr: 'Iowa' },
  { code: 'KS', en: 'Kansas', fr: 'Kansas' },
  { code: 'KY', en: 'Kentucky', fr: 'Kentucky' },
  { code: 'LA', en: 'Louisiana', fr: 'Louisiane' },
  { code: 'ME', en: 'Maine', fr: 'Maine' },
  { code: 'MD', en: 'Maryland', fr: 'Maryland' },
  { code: 'MA', en: 'Massachusetts', fr: 'Massachusetts' },
  { code: 'MI', en: 'Michigan', fr: 'Michigan' },
  { code: 'MN', en: 'Minnesota', fr: 'Minnesota' },
  { code: 'MS', en: 'Mississippi', fr: 'Mississippi' },
  { code: 'MO', en: 'Missouri', fr: 'Missouri' },
  { code: 'MT', en: 'Montana', fr: 'Montana' },
  { code: 'NE', en: 'Nebraska', fr: 'Nebraska' },
  { code: 'NV', en: 'Nevada', fr: 'Nevada' },
  { code: 'NH', en: 'New Hampshire', fr: 'New Hampshire' },
  { code: 'NJ', en: 'New Jersey', fr: 'New Jersey' },
  { code: 'NM', en: 'New Mexico', fr: 'Nouveau-Mexique' },
  { code: 'NY', en: 'New York', fr: 'New York' },
  { code: 'NC', en: 'North Carolina', fr: 'Caroline du Nord' },
  { code: 'ND', en: 'North Dakota', fr: 'Dakota du Nord' },
  { code: 'OH', en: 'Ohio', fr: 'Ohio' },
  { code: 'OK', en: 'Oklahoma', fr: 'Oklahoma' },
  { code: 'OR', en: 'Oregon', fr: 'Oregon' },
  { code: 'PA', en: 'Pennsylvania', fr: 'Pennsylvanie' },
  { code: 'RI', en: 'Rhode Island', fr: 'Rhode Island' },
  { code: 'SC', en: 'South Carolina', fr: 'Caroline du Sud' },
  { code: 'SD', en: 'South Dakota', fr: 'Dakota du Sud' },
  { code: 'TN', en: 'Tennessee', fr: 'Tennessee' },
  { code: 'TX', en: 'Texas', fr: 'Texas' },
  { code: 'UT', en: 'Utah', fr: 'Utah' },
  { code: 'VT', en: 'Vermont', fr: 'Vermont' },
  { code: 'VA', en: 'Virginia', fr: 'Virginie' },
  { code: 'WA', en: 'Washington', fr: 'Washington' },
  { code: 'WV', en: 'West Virginia', fr: 'Virginie-Occidentale' },
  { code: 'WI', en: 'Wisconsin', fr: 'Wisconsin' },
  { code: 'WY', en: 'Wyoming', fr: 'Wyoming' },
];

export const PRICE_RANGES = [
  { value: '500000', en: '$500K', fr: '500K$' },
  { value: '1000000', en: '$1M', fr: '1M$' },
  { value: '2000000', en: '$2M', fr: '2M$' },
  { value: '3000000', en: '$3M', fr: '3M$' },
  { value: '5000000', en: '$5M', fr: '5M$' },
  { value: '7500000', en: '$7.5M', fr: '7,5M$' },
  { value: '10000000', en: '$10M', fr: '10M$' },
  { value: '15000000', en: '$15M', fr: '15M$' },
  { value: '20000000', en: '$20M', fr: '20M$' },
  { value: '25000000', en: '$25M', fr: '25M$' },
  { value: '30000000', en: '$30M', fr: '30M$' },
  { value: '40000000', en: '$40M', fr: '40M$' },
  { value: '50000000', en: '$50M+', fr: '50M$+' },
];
